module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-HeavyItalic.woff?f38e398b8f76ba1a9edc485016724fda";